import { render } from "./IconArrowLeft.vue?vue&type=template&id=4cb949f0"
const script = {}

import "./IconArrowLeft.vue?vue&type=style&index=0&id=4cb949f0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__